import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Small "Beta" indicator shown next to features that are in beta testing.
 *
 * Same markup as the BetaBadge of sporttia-competitions: a fixed blue marker
 * (there is no semantic "info" token) instead of a pill-shaped MUI chip. It
 * carries no margin of its own: the separation from the label is the 8px gap of
 * the menu row, which is what their sidebar shows.
 */
export default function BetaChip(): React.ReactElement {
    const { t } = useTranslation();

    return (
        // Par superficie/texto de información del sistema, no `bg-blue-500`
        // con blanco encima: a 10 px eso daba 3,76:1. Así da 7,34:1.
        <span className="bg-secondary text-secondary-foreground shrink-0 rounded-md px-1 py-0.5 text-[10px] leading-none font-semibold whitespace-nowrap">
            {t('common.beta')}
        </span>
    );
}
